// removed by extract-text-webpack-plugin
module.exports = {"base":"PaginationList_base--21QZ1"};


//////////////////
// WEBPACK FOOTER
// ./components/Pagination/PaginationList/PaginationList.scss
// module id = 2363
// module chunks = 11